import { createContext, useContext } from 'react';
import { DefaultTradingSettingsConfig, DefaultTradingSettingsMethods } from './TradingSettingsContext.types';

export const DefaultTradingSettingsContext = { ...DefaultTradingSettingsConfig, ...DefaultTradingSettingsMethods };
export const TradingSettingsContext = createContext(DefaultTradingSettingsContext);
TradingSettingsContext.displayName = 'TradingSettingsContext';
export const useTradingSettings = () => useContext(TradingSettingsContext);
